import { render, staticRenderFns } from "./databaseWrite.vue?vue&type=template&id=52f6907a&scoped=true&"
import script from "./databaseWrite.vue?vue&type=script&lang=js&"
export * from "./databaseWrite.vue?vue&type=script&lang=js&"
import style0 from "./databaseWrite.vue?vue&type=style&index=0&id=52f6907a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f6907a",
  null
  
)

export default component.exports